import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import { LightThemeProvider } from '@qflow/theme'

import { DesignMatches } from 'portal/components/DesignMatches'
import { Sidebar } from 'portal/components/Sidebar'
import { useUserProjectRole } from 'portal/lib/hooks'
import { SmallSpinner } from 'portal/lib/primitives'
import { PageContainer } from 'portal/pages/PageContainer'
import { FORBIDDEN } from 'portal/routes'

export function DeliveryDesignMatches() {
  const navigate = useNavigate()
  const { accountId, projectId } = useParams()

  const authState = useSelector(state => state.auth)
  const accountDetails = authState.accounts?.find(
    account => account.accountId === accountId
  )
  const userIsAccountAdmin = accountDetails?.isAdmin === true
  const { isProjectAdmin, roleLoaded } = useUserProjectRole(
    accountId,
    projectId
  )

  const hasRole = userIsAccountAdmin || isProjectAdmin
  // Account Admins never get a project-permission entry, so `roleLoaded` alone
  // would never settle for them - only wait on it once we know they aren't already admin.
  const isReady = roleLoaded || hasRole

  useEffect(() => {
    if (isReady && !hasRole) {
      navigate(FORBIDDEN)
    }
  }, [isReady, hasRole, navigate])

  if (!isReady || !hasRole) {
    return (
      <LightThemeProvider>
        <Sidebar />
        <PageContainer>{!isReady && <SmallSpinner />}</PageContainer>
      </LightThemeProvider>
    )
  }

  return (
    <LightThemeProvider>
      <Sidebar />
      <PageContainer>
        <DesignMatches />
      </PageContainer>
    </LightThemeProvider>
  )
}
